import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getRegulationBaseFinanceAttributions(companyId, regulationId) {
	return dataTransferWrap(
		ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].getRegulationBaseFinanceAttributions,
		{
			urlParams: {
				companyId: companyId,
				regulationId,
			},
		},
	)
}

function createRegulationBaseFinanceAttribution(companyId, regulationId, data) {
	return dataTransferWrap(ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].createRegulationBaseFinanceAttribution, {
		urlParams: {
			companyId,
			regulationId,
		},
		...data,
	})
}

function getRegulationBaseFinanceAttribution(companyId, regulationId, financeAttributionId) {
	return dataTransferWrap(ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].getRegulationBaseFinanceAttribution, {
		urlParams: {
			companyId,
			regulationId,
			financeAttributionId,
		},
	})
}

function patchRegulationBaseFinanceAttribution(companyId, regulationId, financeAttributionId, data) {
	return dataTransferWrap(ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].patchRegulationBaseFinanceAttribution, {
		urlParams: {
			companyId,
			regulationId,
			financeAttributionId,
		},
		...data,
	})
}

function putRegulationBaseFinanceAttribution(companyId, regulationId, financeAttributionId, data) {
	return dataTransferWrap(ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].putRegulationBaseFinanceAttribution, {
		urlParams: {
			companyId,
			regulationId,
			financeAttributionId,
		},
		...data,
	})
}

function deleteRegulationBaseFinanceAttribution(companyId, regulationId, financeAttributionId) {
	return dataTransferWrap(ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION,dtConfig[ModulesMap.REGULATION_BASE_FINANCE_ATTRIBUTION].deleteRegulationBaseFinanceAttribution, {
		urlParams: {
			companyId,
			regulationId,
			financeAttributionId,
		},
	})
}

export default {
	getRegulationBaseFinanceAttributions,
	getRegulationBaseFinanceAttribution,
	patchRegulationBaseFinanceAttribution,
	putRegulationBaseFinanceAttribution,
	createRegulationBaseFinanceAttribution,
	deleteRegulationBaseFinanceAttribution,
}
